import {LatLngExpression} from "leaflet"

export const latLngExpressionToString = (value: LatLngExpression|null, round: number = 15) => {
  let lat, lng
  if(value){
    if(Array.isArray(value)){
      [lat, lng] = value
    }
    else{
      ({lat, lng} = value)
    }
    return `${Number(lat.toPrecision(round))}, ${Number(lng.toPrecision(round))}`
  }
  return ""
}